import React, {PureComponent} from 'react';
import PlayerComponent from '../../components/player'
import {database} from "../../logic/firebase";
import {changeCurrentTrackWithDelay} from "../../logic/api";

export default class PlayerContainer extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            isCurrentTrackPlayed: false,
            trackVotes: null
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentTrack !== this.props.currentTrack) {
            this.checkIsPlayed();
            this.getVotes();
        }
    }

    componentDidCatch(e){
        console.log('AAAAAA')
    }

    componentDidMount() {
        this.checkIsPlayed();
        this.getVotes();
    }

    getVotes = () => {
        console.log(this.props.currentTrack.track_id)
        const votesRef = database().ref('/votes/'+this.props.currentTrack.track_id);
        votesRef.on('value', (snapshot) =>
            this.setState({trackVotes: snapshot.val()})
        )
    };

    hideCurrentTrack = async () => {
        await this.moveToPlayed();
        await database().ref('/translation/currentTrack').remove();
        await changeCurrentTrackWithDelay();
    };

    moveToPlayed = async () => {
        const {currentTrack} = this.props;
        await database().ref('/translation/playedTracks/' + currentTrack.track_id).set(currentTrack);
    };

    replayTrack = () => {
        const {currentTrack} = this.props;
        database().ref('/translation/playedTracks/' + currentTrack.track_id).remove();
    };

    checkIsPlayed = () => {
        const tracksRef = database().ref('/translation/playedTracks');
        tracksRef.on('value', (snapshot) => {
                const {currentTrack} = this.props;
                if (currentTrack) {
                    const playedTracks = snapshot.val() || {};
                    const isCurrentTrackPlayed = !!playedTracks[currentTrack.track_id];
                    this.setState({isCurrentTrackPlayed})
                }
            }
        )
    };

    render() {
        const {isCurrentTrackPlayed, trackVotes} = this.state;
        const {currentTrack, currentTrackIndex, showTally} = this.props;

        return (
            <PlayerComponent
                showTally={showTally}
                trackVotes={trackVotes}
                currentTrackIndex={currentTrackIndex}
                hideCurrentTrack={this.hideCurrentTrack}
                isCurrentTrackPlayed={isCurrentTrackPlayed}
                replayTrack={this.replayTrack}
                moveToPlayed={this.moveToPlayed}
                currentTrack={currentTrack}
            />
        )
    }
}